var exports = {
  "k": "xcc377c0b--9dbcc7--container",
  "P": "xcc377c0b--9dbcc7--label",
};

module.exports = exports;
